import { render, staticRenderFns } from "./WebsocketComponent.vue?vue&type=template&id=931eed9e&scoped=true&"
import script from "./WebsocketComponent.vue?vue&type=script&lang=js&"
export * from "./WebsocketComponent.vue?vue&type=script&lang=js&"
import style0 from "./WebsocketComponent.vue?vue&type=style&index=0&id=931eed9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931eed9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VCard,VDataTable,VDialog,VIcon,VTooltip})
